import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import './chart-box-block.scss'

function mountChartBoxBlocks() {
	const blocks = [...document.querySelectorAll('[data-chart-box]')];

	blocks.forEach((block) => {
		const app = createApp({
			name: 'ChartBoxBlockApp',
		});
		app.component('chart-box-block', defineAsyncComponent(
			() => import('./ChartBoxBlock.vue')
		));
		app.use(store);
		app.mount(block);
	});
}

mountChartBoxBlocks();
